<template>
  <section class="container ask">
    <NormalHeader :languageBtn="true" />
    <div class="conts">
      <div class="wapper">
        <h2>{{ $t('출입등록') }}</h2>
        <blockquote v-if=" (getUserType === USER.NOK || getUserType == USER.ENOK) && isNeedAuth"
          v-html=" $t('동행할_환자의_병원등록번호_또는_휴대전화번호_생년월일을_입력해주세요_v2')" />
        <blockquote v-else-if=" (getUserType === USER.NOK || getUserType == USER.ENOK)"
          v-html=" $t('동행할_환자의_병원등록번호_또는_휴대전화번호_생년월일을_입력해주세요')" />
        <blockquote v-else-if="getUserType === USER.PT &&  isNeedAuth"
          v-html="$t('병원등록번호_또는_휴대전화번호와_생년월일을_입력해주세요')" />
        <blockquote v-else-if="getUserType === USER.PT"
          v-html="$t('병원등록번호_또는_휴대전화번호_생년월일을_입력해주세요')" />
        <blockquote v-else
          v-html="$t('방문할_환자의_병원등록번호_또는_휴대전화번호_생년월일을_입력해주세요')" />

        <div class="num_box" :class="{ 'disabled-area': step === 'AUTH' }">
          <div class="tabs" >
            <div @click="step === 'INPUT' ? switchTap($event, 'pid') : null"  style="width:50%"
                 :class="{ selected: isPidTab }" class="item">
              {{ $t('병원등록번호') }}
            </div>
            <div @click="step === 'INPUT' ? switchTap($event, 'birth') : null"  style="width:50%"
                 :class="{ selected: !isPidTab }" class="item" v-html="$t('휴대전화번호')" />
          </div>

          <div class="patient_cont">
            <template v-if="isPidTab">
              <input type="tel" placeholder="12345678" :readonly="isPidLock || step === 'AUTH'" 
                     v-model="identityNo" @keyup.enter="step === 'INPUT' ? goSelectPopup() : null" />
            </template>
            <template v-else>
              <input type="tel" placeholder="010-1234-5678" v-model="phoneNum" :readonly="step === 'AUTH'" />
            </template>
            <input v-if="$route.name=='pt_sec' || !isPidTab"
             type="tel" class="small-placeholder" :placeholder="`${$t('생년월일')}(YYYYMMDD)`" 
                  v-model="birthDay" :readonly="step === 'AUTH'" />
          </div>
        </div>

        <timerComponent 
          v-if="step === 'AUTH' && isNeedAuth"
          v-model="inputAuthCode"
          :targetInfo="{ id: identityNo, phone: phoneNum, birth: birthDay, type: getUserType }"
          @resend="reqSendAuthCode"
          @enter="goSelectPopup"
          @cancel="resetStep"
        />

        <div class="btn_area">
          <button :class="{ disabled: !canNext }" @click="goSelectPopup">
            {{ $t('확_인') }}
          </button>
        </div>
      </div>
    </div>
    <SelectPopup
      v-if="popup.selectPopup"
      :userList="popup.selectPopupUserList"
      :byPid="isPidTab"
      @okBtn="goNext"
      @closePopup="closePopup"
    />
  </section>
</template>
<script>
// import Terms from '../../components/v2/Terms.vue';
import NormalHeader from '../../components/v2/NormalHeader.vue';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import moment from 'moment';
import debounce from 'lodash/debounce';
import SelectPopup from '../../components/v2/popup/SelectPopup.vue';
import timerComponent from '../../components/v2/timerComponent.vue';

export default {
  name: 'patient',
  components: {
    // Terms,
    NormalHeader,
    SelectPopup,
    timerComponent,
  },
  data: () => {
    return {
      isPidTab: true,
      isPidLock: false, // url query에 pid 를 달고 들어온 경우 true로 셋팅되면 입력필드 제한됨
      visitDate: null, //방문예정일
      isTermChecked: true, // 약관 동의 여부(2개)
      identityNo: null, //환자번호
      token: null, // 받은 토큰값
      phoneNum: '', // 휴대전화번호
      birthDay: '', // 생년월일 YYYYMMDD
      popup: {
        selectPopup: false,
        selectPopupUserList: [],
      },
      answerType: null,
      
      // [상태 관리]
      step: 'INPUT',       // 'INPUT' | 'AUTH'
      inputAuthCode: '',   // 인증번호 입력값
      txId: '', // OTP용 신규 변수
    }
  },
  computed: {
    ...mapState(['USER']),
    ...mapGetters(['getUserType', 'getCnnHome']),
    isNeedAuth: function () { 
      const source = localStorage.getItem('cnnHome') || this.getCnnHome
      const currentRoute = this.$route.name
      if ((source =='C' || source == 'H')  && currentRoute === 'pt_sec') {
        return true
      }
      return false
    },
    canNext: function () {
      // 1. 인증 단계: 코드 6자리 체크
      if (this.step === 'AUTH') {
        return this.inputAuthCode && this.inputAuthCode.length >= 6
      }

      // 2. 입력 단계: 기존 유효성 로직
      if (this.isPidTab) {

        return (
          // 병원등록번호 정상 여부 확인
          this.identityNo !== null &&
          this.identityNo !== '' &&
          this.identityNo.length > 7 &&
          // 생년월일 조건부 확인 (필수가 아니면 무조건 true 처리)
          (!this.isNeedAuth || (
            this.birthDay !== null &&
            this.birthDay !== '' &&
            this.birthDay.length === 8 &&
            moment(this.birthDay).format() !== 'Invalid date'
          )) &&
          // 약관 동의 여부확인
          (this.getUserType === this.USER.NOK ||
            this.getUserType === this.USER.ENOK ||
            this.isTermChecked)
        )
      } else {
        return (
          // 핸드폰 번호 입력값 확인
          this.phoneNum !== null &&
          this.phoneNum !== '' &&
          this.phoneNum.length > 9 &&
          /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/.test(
            this.phoneNum
          ) &&
          // 생년월일 입력값 확인 (핸드폰 탭에서는 항상 필수)
          this.birthDay !== null &&
          this.birthDay !== '' &&
          this.birthDay.length === 8 &&
          moment(this.birthDay).format() !== 'Invalid date' &&
          // 약관 동의 여부 확인
          (this.getUserType === this.USER.NOK ||
            this.getUserType === this.USER.ENOK ||
            this.isTermChecked)
        )
      }
    },
  },
  // async mounted() {
  //   if (this.getUserType === null) {
  //     if(this.$route.query.type) {
  //       this.setUserType(window.atob(this.$route.query.type || 'PT'))
  //     } else {
  //       this.setUserType(this.USER.PT);
  //     }
  //   }
  //   if (this.$route.query.ptno) {
  //     this.identityNo = window.atob(this.$route.query.ptno);
  //     this.token = window.atob(this.$route.query.tk);
  //     this.isPidLock = true;
  //     console.log('현재위치 patient token: ',  this.token)
  //   }
  //   this.visitDate = this.$route.query.vd
  //     ? window.atob(this.$route.query.vd)
  //     : null
  //   if (!this.visitDate || this.visitDate < moment().format('YYYYMMDD')) {
  //     this.$router.replace({ name: 'error' });
  //   }
  // },
  async mounted() {
    const { type, ptno, tk, vd } = this.$route.query
    if (this.getUserType === null) {
      if (type) {
        try {
          this.setUserType(window.atob(type))
        } catch (error) {
          this.setUserType(this.USER.PT)
        }
      } else {
        this.setUserType(this.USER.PT)
      }
    }
    if (ptno) {
      try {
        this.identityNo = window.atob(ptno)
        this.token = tk ? window.atob(tk) : null
        this.isPidLock = true
        console.log('현재위치 patient token: ', this.token)
      } catch (error) {
      }
    }

    try {
      this.visitDate = vd ? window.atob(vd) : null
    } catch (error) {
      this.visitDate = null
    }

    if (!this.visitDate || this.visitDate < moment().format('YYYYMMDD')) {
      return this.$router.replace({ name: 'error' })
    }
  },
  watch: {
    identityNo: function (newVal) {
      if (this.step === 'AUTH') return
      this.identityNo = newVal
        .replace(/[ㄱ-힣~!@#$%^&*()_+|<>?:{}= ]/g, '')
        .substring(0, 8);
    },
    phoneNum: function (newVal) {
      this.phoneNum = this.phoneFormatter(
        newVal.replace(/[^0-9]/g, '').substring(0, 11)
      )
    },
    birthDay: function (newVal) {
      this.birthDay = newVal.replace(/[^0-9]/g, '').substring(0, 8)
    },
    isPidTab: function () {
      this.identityNo = '';
      this.token = null;
      this.phoneNum = '';
      this.birthDay = '';
    },
  },
  methods: {
    ...mapMutations(['setUserType']),
    /**
     * 하단 버튼 클릭 시 단계별 분기 처리
     */
    async goSelectPopup() {
      // 1. PID Lock 상태 예외 처리
      if (this.isPidLock && this.isPidTab && this.step === 'INPUT') {
        if (this.isNeedAuth) {
          const sent = await this.reqSendAuthCode();
          if(sent) this.step = 'AUTH';
        } else {
          this.goNext(this.token)
          // this.apiCheckPatient();
        }
        return;
      }

      // 2. 버튼 비활성화 시 중단
      if (!this.canNext) return;

      // 3. [입력 단계] -> 접속 경로에 따라 인증번호 발송 또는 API 바로 호출
      if (this.step === 'INPUT') {
        if (this.isNeedAuth) {
          // 홈페이지 / 내손안의차트인 경우 인증번호 발송
          const sent = await this.reqSendAuthCode();
          console.log(sent);
          if (sent) {
            this.step = 'AUTH';
          }
        } else {
          if (this.isPidTab) {
            this.goNext(this.token)
          } else {
            this.apiIdentityPhonebirth();
          }
        }
        return; 
      }

      // 4. [인증 단계] -> 인증번호 검증 -> (성공 시) 환자 조회 -> 팝업
      if (this.step === 'AUTH') {
        await this.reqVerifyAuthCode();
      }
    },

    /**
     * 인증번호 발송 API ** getCnnHome== C 또는 H 인 경우에만 발송
     */
    async reqSendAuthCode() {
      try {
        this.$modal.loading(true)
        let body = {
          answerType: this.getUserType,
          visitDate: moment().format("YYYYMMDD"),
          birth: this.birthDay,
        }
        if (this.isPidTab) {
          body.patNo= this.identityNo
          body.phoneNum = null
          body.verifyMethod="PATNO_BIRTH"
        } else {
          body.patNo = null
          body.phoneNum = this.phoneNum.replace(/-/g, '')
          body.verifyMethod="PHONE_BIRTH"
        }

        const res = await this.$axios.post('/api/v1/identity/auth/start', body)

        if (res.data.resultCd === 0) {
          this.txId = res.data.result.txId 
          return true
        } else if (res.data.resultCd === 300) {
          this.$modal.error(
            `${this.$t("환자_재원정보가_확인되지_않습니다")}<br />${this.$t("병원등록번호를_다시_확인해주세요")}`
          )
          return false
        } else if (res.data.resultCd === 901) { // 인증번호 발송 제한
          this.$modal.error(
            `${this.$t('인증번호 발송에 실패했습니다. 잠시후 다시 시도해주세요.')}` //다국어 없음 확인 
          )
          return false
        }else if (res.data.resultCd === 999) {
          this.$modal.error(this.$t('인증번호_발송에_실패했습니다'))
          return false
        } else {
          this.$modal.error()
          return false
        }

      } catch (e) {
        return false
      } finally {
        this.$modal.loading(false)
      }
    },

    /**
     * 인증번호 검증 API
     */
    async reqVerifyAuthCode() {
      // timerComponent에서 v-model로 받은 inputAuthCode 사용
      if (!this.inputAuthCode) return false

      const response = await this.$axios.post('/api/v1/identity/auth/verify', {
        txId: this.txId,
        otp: this.inputAuthCode,
        patNo: this.identityNo,
    
      })
      console.log(response)
      if(response.data.resultCd === 0) {
        this.showSelectPopup([{
          patNum: response.data.result.patNo,
          ptName: response.data.result.patNm,
          birth: response.data.result.patBirth,
          token: response.data.result.token, 
        }])
      } else if (response.data.resultCd == "-1") { 
        this.$modal.error(
          `${this.$t('인증번호가_일치하지_않습니다.')}<br />${this.$t('다시_확인해주세요.')}`
        )
      } else if (response.data.resultCd === 429) { 
        this.$modal.error(
          `${this.$t('인증_시도_횟수가_만료되었습니다.')}<br />${this.$t('처음부터_다시_진행해_주세요.')}` 
        )
      } else {
        this.$modal.error()
      }
    },

    resetStep() {
      this.step = 'INPUT'
      this.inputAuthCode = ''
    },

    switchTap(_e, type) {
      if (type === 'pid') this.isPidTab = true;
      else if (type === 'birth' && !this.isPidLock) this.isPidTab = false;
    },
    // 환자 번호가 존재하는지 체크 후 팝업 노출 Method --> 보안 강화로 사용하지 않음 
    apiCheckPatient: debounce(
      async function () {
        this.$modal.loading(true);
        try {
          // check-patient는 모바일 전용 
          const response = await this.$axios.post(
            '/api/v1/identity/check-patient',
            {
              identityNo: this.token,
              // birth: this.birthDay,
            });
            
            switch (response.data.resultCd) {
              case 300:
                // 300 : 병원등록번호로 조회된 환자없음
                this.$modal.error(
                  `${this.$t(
                    '병원등록번호가_확인되지_않습니다'
                  )}<br /><br />${this.$t('병원등록번호를_다시_확인해주세요')}`
                );
                break;
              case 0:
                // 정상 조회 완료 (팝업노출)
                this.showSelectPopup([
                  {
                    patNum: response.data.result.patNo,
                    token: response.data.result.token,
                    ptName: response.data.result.patNm,
                    birth: response.data.result.patBirth,
                  },
                ]);
                break;
              default:
                throw new Error('정의되지 않은 resultCd 오류');
            }
         
        } catch (error) {
          this.goError();
          console.log(error);
        } finally {
          this.$modal.loading(false);
        }
      },
      1000,
      { leading: true, trailing: false }
    ),
    async apiIdentityPhonebirth() {
      try {
        this.$modal.loading(true);
        const response = await this.$axios.post(
          '/api/v1/identity/phone-birth',
          {
            phoneNum: this.phoneNum.replace(/-/g, ''),
            birth: this.birthDay,
          }
        );
        // if (!response.data.success) throw new Error("error");
        switch (response.data.resultCd) {
          case 0:
          case 303:
            // 0 : 생년월일+전화번호로 조회된 환자 1명
            // 303 : 생년월일로 조회된 환자 여러명
            this.showSelectPopup(
              response.data.result.map(({ patNum, ptName, birth, token }) => ({
                patNum: patNum,
                ptName: ptName,
                birth: birth,
                token: token
              }))
            );
            break;
          case 300:
            // 300 : 생년월일+전화번호로 조회된 환자없음
            this.$modal.error(
              `${this.$t(
                '병원등록번호가_확인되지_않습니다'
              )}<br />${this.$t('병원등록번호를_다시_확인해주세요')}`
            );
            break;
          default:
            throw new Error('정의되지 않은 resultCd 오류');
        }
      } catch (error) {
        this.$modal.error()
      } finally {
        this.$modal.loading(false)
      }
    },
    showSelectPopup(userList) {
      console.log( `[System] 팝업에 전달할 환자 리스트:`, userList)
      this.popup.selectPopupUserList = userList
      this.popup.selectPopup = true
    },
    closePopup() {
      this.popup.selectPopup = false
    },
    goError() {
      this.$router.push({
        name: 'error',
        params: { titleText: '진료_일정이_확인되지_않습니다' },
      })
    },

    goNext: debounce(
      async function (patientId) {
        this.identityNo = patientId
        this.closePopup()
        try {
          const response = await this.fetchPatientData(patientId)
          this.token = patientId

          if (this.getUserType === this.USER.PT) {
            console.log('goNext 눌렸음, response:', response)
            console.log('goNext 눌렸음, identityNo:', this.identityNo)
            await this.goInquiry(response)
          } else if (
            this.getUserType === this.USER.NOK || 
            this.getUserType === this.USER.ICUGST
          ) {
            this.goPhone(response, patientId)
          } else {
            throw new Error(`정의되지 않은 UserType: ${this.getUserType}`)
          }
        } catch (error) {
          this.goError()
        }
      },
      1000,
      { leading: true, trailing: false }
    ),

    async fetchPatientData(patientId) {
      if (this.getUserType === this.USER.ICUGST) {
        return await this.$axios.post("/api/v1/identity/check-icu-patient", {
          refId: this.identityNo,
          answerType: this.getUserType,
          visitDate: moment().format("YYYYMMDD"),
        })
      }
      return await this.$axios.post('/api/v3/identity/patient', {
        identityNo: patientId,
        answerType: this.getUserType,
        visitDate: this.visitDate,
      })
    },

    async goInquiry(response) {
      switch (response.data.resultCd) {
        case 301: 
          this.goError()
          break
        case 201: 
          this.$router.push({ 
            name: 'passForbiden', 
            query: { pass: response.data.result.passCheck } 
          })
          break
        case 200: 
          this.$router.push({ 
            name: 'pass', 
            query: { 
              pass: response.data.result.passCheck, 
              isDirect: 'N', 
              inqType: response.data.result.inquiryType 
            } 
          })
          break
        case 0: 
          console.log('goInquiry token:', this.token)
          this.$router.push({ 
            name: 'infoAgree', 
            query: { 
              type: window.btoa(this.getUserType), 
              itype: window.btoa(response.data.result.inquiryType), 
              idn: window.btoa(this.token), // 기존에 identityNo로 넘기던 값을 token으로 변경
              vd: window.btoa(this.visitDate), 
              pid: this.$route.query.pid 
            } 
          })
          break
        default: 
          throw new Error('정의되지 않은 resultCd 오류')
      }
    },

    goPhone(response, refId) {
      switch (response.data.resultCd) {
        case 301: 
          this.goError()
          break
        case 311: 
          this.$modal.error(
            `${this.$t("환자_재원정보가_확인되지_않습니다")}<br /><br />${this.$t("병원등록번호를_다시_확인해주세요")}`
          )
          break
        case 201:
        case 200:
        case 0:
          this.$router.push({ 
            name: 'phoneNum', 
            query: { 
              refId: window.btoa(refId), 
              vd: window.btoa(this.visitDate), 
              vcnt: response.data.result.vistCntAES ? response.data.result.vistCntAES : null, 
              type: window.btoa(this.getUserType) 
            } 
          })
          break
        default: 
          throw new Error('정의되지 않은 resultCd 오류')
      }
    },  
    phoneFormatter(num, type) {
      let formatNum = '';
      try {
        if (num.length === 11) {
          if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
          }
        } else if (num.length === 8) {
          formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2')
        } else {
          if (num.indexOf('02') === 0) {
            if (type === 0) {
              formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3')
            } else {
              formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
            }
          } else {
            if (type === 0) {
              formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3')
            } else {
              formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
            }
          }
        }
      } catch (e) {
        formatNum = num
      }
      return formatNum
    },
  },
}
</script>

<style scoped>
.disabled-area {
  opacity: 0.6;
  pointer-events: none;
  filter: grayscale(0.5);
  transition: all 0.3s;
}
</style>